export default "__VITE_ASSET__ClWJ8mVk__"